function injectStyle (ssrContext) {
  require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-644a7f72\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector?type=styles&index=0!./PixelSpinner.vue")
}
var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./PixelSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-644a7f72\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../vue-loader/lib/selector?type=template&index=0!./PixelSpinner.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-644a7f72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/PixelSpinner.vue
// module id = 239
// module chunks = 1